import { Stack, Tab, Tabs, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Project, User } from '../../../store/types'
import AutocompleteEmployees from '../../Notification/AutocompleteEmployees'
import AutocompleteLeaders from '../../Notification/AutocompleteLeaders'
import AutocompleteProjects from '../../Notification/AutocompleteProjects'

interface RecipientsTabsProps {
  tabValue: number
  setTabValue: (value: number) => void
  selectedEmployees: User[]
  setSelectedEmployees: (users: User[]) => void
  selectedLeaders: User[]
  setSelectedLeaders: (users: User[]) => void
  selectedProjects: Project[]
  setSelectedProjects: (projects: Project[]) => void
  currentUser: User | null
}

const RecipientsTabs = ({
  tabValue,
  setTabValue,
  selectedEmployees,
  setSelectedEmployees,
  selectedLeaders,
  setSelectedLeaders,
  selectedProjects,
  setSelectedProjects,
  currentUser
}: RecipientsTabsProps) => {
  const { t } = useTranslation()

  const handleTabChange = (newValue: number) => {
    setTabValue(newValue)
    setSelectedEmployees([])
    setSelectedLeaders([])
    setSelectedProjects([])
  }

  return (
    <Stack direction={'column'} sx={{ gap: 2 }}>
      <Tabs
        value={tabValue}
        onChange={(_, v) => handleTabChange(v)}
        indicatorColor="secondary"
        textColor="inherit"
        variant="fullWidth"
        aria-label="full width tabs example"
      >
        <Tab label={t('components.notificationSidebar.missingHoursNotification.item1')} />
        <Tab label={t('components.notificationSidebar.missingHoursNotification.item2')} />
        <Tab label={t('components.notificationSidebar.missingHoursNotification.item3')} />
      </Tabs>

      {tabValue === 0 && (
        <Stack direction={'column'} sx={{ gap: 2 }}>
          <Typography fontSize={'small'} fontStyle={'italic'} color="text.base">
            {t('components.notificationSidebar.missingHoursNotification.descriptionItem1')}
          </Typography>
          <AutocompleteEmployees
            selectedEmployees={selectedEmployees}
            setSelectedEmployees={setSelectedEmployees}
            currentUser={currentUser}
          />
        </Stack>
      )}
      {tabValue === 1 && (
        <Stack direction={'column'} sx={{ gap: 2 }}>
          <Typography fontSize={'small'} fontStyle={'italic'} color="text.base">
            {t('components.notificationSidebar.missingHoursNotification.descriptionItem2')}
          </Typography>
          <AutocompleteLeaders
            selectedLeaders={selectedLeaders}
            setSelectedLeaders={setSelectedLeaders}
            currentUser={currentUser}
          />
        </Stack>
      )}
      {tabValue === 2 && (
        <Stack direction={'column'} sx={{ gap: 2 }}>
          <Typography fontSize={'small'} fontStyle={'italic'} color="text.base">
            {t('components.notificationSidebar.missingHoursNotification.descriptionItem3')}
          </Typography>
          <AutocompleteProjects
            selectedProjects={selectedProjects}
            setSelectedProjects={setSelectedProjects}
          />
        </Stack>
      )}
    </Stack>
  )
}

export default RecipientsTabs